// Static data for Equinesport

export const FOCUS_WORDS = [
  { text: "Køb af heste", description: "Acquisition of elite prospects" },
  { text: "Salg af heste", description: "Global sales network" },
  { text: "Uddannelse", description: "World-class education" },
  { text: "Individuel træning", description: "Tailored athletic development" },
  { text: "Siden 2012", description: "Over a decade of excellence" }
];

export const ABOUT_US_TEXT = {
  title: "About Us",
  subtitle: "Decades of Elite Equestrian Excellence",
  paragraphs: [
    "Equinesport was founded in 2012 by international Grand Prix rider Marcus Heineking and professional equestrian Rikke Heineking. Based on a foundation of passion, compromise-free quality, and decades of elite-level experience, we specialize in the acquisition, training, and sales of world-class show jumping horses.",
    "Our philosophy centers on the individual development of each horse, unlocking their full athletic potential through tailored training programs. We believe that elite performance is the result of meticulous care, correct basic training, and a deep understanding of the equine athlete.",
    "Over the years, Equinesport has established a global reputation as a trusted partner for riders and owners seeking horses of the absolute highest caliber. Whether you are looking for an experienced Grand Prix competitor or a promising young prospect with championship potential, our selection represents the pinnacle of modern sport horse breeding and education."
  ],
  profiles: [
    {
      name: "Marcus Heineking",
      role: "Co-founder & Elite Trainer",
      phone: "52174997",
      email: "marcus@equinesport.dk",
      bio: "International Grand Prix rider with numerous victories and placings at the highest levels of show jumping. Marcus is renowned for his exceptional ability to educate young horses up to international Grand Prix level."
    },
    {
      name: "Rikke Heineking",
      role: "Co-founder & Elite Rider",
      phone: "20293430",
      email: "rikke@equinesport.dk",
      bio: "Professional equestrian and trainer with a deep passion for horse welfare and flatwork. Rikke manages the daily operations, training programs, and ensures every horse receives individual, world-class care."
    }
  ]
};

export const CONTACT_INFO = {
  address: "Equinesport, Denmark",
  generalPhone: "52174997",
  generalEmail: "info@equinesport.dk",
  socials: {
    facebook: "https://www.facebook.com/profile.php?id=100049515199004#",
    youtube: "https://www.youtube.com/user/EquineSport1",
    instagram: "https://www.instagram.com/equinesport_eqs/"
  }
};
